import React from 'react';
import { Box, Typography } from '@mui/material';
import ImprovementPlan from '../ImprovementPlanComponents/ImprovementPlan';
import { PropertyAnalysis } from '../../models/improvementPlan';

interface PropertyInspectionDisplayProps {
  propertyAnalysis: PropertyAnalysis;
}

const PropertyInspectionDisplay: React.FC<PropertyInspectionDisplayProps> = ({ propertyAnalysis }) => {
  return (
    <Box>
      <ImprovementPlan improvementPlan={propertyAnalysis.ImprovementPlan} />
    </Box>
  );
};

export default PropertyInspectionDisplay;
